/* tslint:disable */
/* eslint-disable */
/**
 * Documents API
 * CDI Documents API
 *
 * The version of the OpenAPI document: 1.33.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from '../runtime';
import { DocumentLanguageFromJSON, DocumentLanguageFromJSONTyped, DocumentLanguageToJSON } from './DocumentLanguage';
/**
 * Check if a given object implements the UserDetail interface.
 */
export function instanceOfUserDetail(value) {
    let isInstance = true;
    return isInstance;
}
export function UserDetailFromJSON(json) {
    return UserDetailFromJSONTyped(json, false);
}
export function UserDetailFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: !exists(json, 'id') ? undefined : json['id'],
        keycloakId: !exists(json, 'keycloakId') ? undefined : json['keycloakId'],
        username: !exists(json, 'username') ? undefined : json['username'],
        country: !exists(json, 'country') ? undefined : json['country'],
        communicationLanguage: !exists(json, 'communicationLanguage')
            ? undefined
            : json['communicationLanguage'],
        languages: !exists(json, 'languages')
            ? undefined
            : json['languages'].map(DocumentLanguageFromJSON)
    };
}
export function UserDetailToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        keycloakId: value.keycloakId,
        username: value.username,
        country: value.country,
        communicationLanguage: value.communicationLanguage,
        languages: value.languages === undefined
            ? undefined
            : value.languages.map(DocumentLanguageToJSON)
    };
}
